export default "__VITE_ASSET__DHKdG0Gz__"